import { render, staticRenderFns } from "./ViewerPropertiesPanel.vue?vue&type=template&id=8f03cfee&scoped=true"
import script from "./ViewerPropertiesPanel.vue?vue&type=script&lang=js"
export * from "./ViewerPropertiesPanel.vue?vue&type=script&lang=js"
import style0 from "./ViewerPropertiesPanel.vue?vue&type=style&index=0&id=8f03cfee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f03cfee",
  null
  
)

export default component.exports